<template>
  <div class="home">
    <Page1></Page1>
    <Page2 ref="page2"></Page2>
    <Page3 ref="page3"></Page3>
    <Page4></Page4>
    <Page5></Page5>
    <Page6></Page6>
    <Page7></Page7>
    <Page8></Page8>
  </div>
</template>

<script>
import {
  Page1,
  Page2,
  Page3,
  Page4,
  Page5,
  Page6,
  Page7,
  Page8,
} from "@/components/home/index";
import "element-ui/lib/theme-chalk/display.css";

export default {
  name: "home",
  components: {
    Page1,
    Page2,
    Page3,
    Page4,
    Page5,
    Page6,
    Page7,
    Page8,
  },
  data() {
    return {};
  },
  mounted() {
    window.addEventListener("scroll", this.handleScrollbox, true);
  },
  methods: {
    // 监控滚动
    handleScrollbox() {
      this.currentScroll = window.pageYOffset;
      if (this.currentScroll >= this.$refs.page2.$el.offsetTop - 600) {
        this.$refs.page2.setAnimate();
      }
      if (this.currentScroll >= this.$refs.page3.$el.offsetTop - 600) {
        this.$refs.page3.setCountTo();
        window.removeEventListener("scroll", this.handleScrollbox, true);
      }
    },
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScrollbox, true);
  },
};
</script>
<style lang="scss" scoped>
.home {
  text-align: center;
  color: #ffffff;
  overflow-x: hidden;
  overflow-y: auto;
  a {
    color: #ffffff;
  }
}
.home::-webkit-scrollbar {
  width: 0;
  height: 0;
}
.block {
  height: 300px;
  width: 200px;
  background: #ff715e;
}
.page2,
.page4,
.page5,
.page6,
.page7,
.page8 {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.img-test {
  background: url("~@/assets/logo.png") no-repeat;
  width: 300px;
  height: 300px;
  background-size: cover;
}
.sub_scroll-test-box {
  margin: 0px auto;
  height: 200px;
  width: 300px;
  border: 1px solid #ff715e;
  color: #ffffff;
  background: #ff715e;
  overflow-y: auto;
  overflow-x: hidden;
}
.color-red {
  color: aquamarine;
}
</style>
<style lang="scss">
.home {
  font-size: 14px;
  .myMain {
    max-width: 1200px;
    margin: 0 auto;
  }
  .title-box {
    .title-chinese {
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      div {
        display: flex;
        flex-direction: column;
        .line {
          width: 84px;
          height: 2px;

          background: #d8d8d8;
          border-radius: 3px;
          &:nth-child(1) {
            margin-bottom: 4px;
          }
        }
      }
      h3 {
        font-size: 38px;
        font-weight: 500;
        color: #da5351;
        line-height: 38px;
        margin: 0 22px;
        a{
          text-decoration: none;
          color: inherit;
        }
      }
    }
    .title-english {
      .about {
        font-size: 18px;
        font-weight: 500;
        color: #999999;
        line-height: 24px;
        margin: 16px 0 34px 0;
      }
    }
  }
}
@media screen and (max-width: 960px) {
  .home {
    .myMain {
      width: 100%;
    }
    .title-box {
      .title-chinese {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        div {
          display: flex;
          flex-direction: column;
          .line {
            width: 0.2rem;
            height: 1px;
            background: #cc3b3f;
            border-radius: 0.03ren;
            opacity: 0.49;
            &:nth-child(1) {
              margin-bottom: 0.02rem;
            }
          }
        }
        h3 {
          font-weight: 500;
          color: #333333;
          font-size: 0.2rem;
          line-height: 0.2rem;
          margin: 0 0.12rem;
        }
      }
      .title-english {
        .about {
          margin: 0.08rem 0 0.24rem 0;
          font-size: 0.12rem;
          line-height: 0.12rem;
          color: #666666;
        }
      }
    }
  }
}
</style>